export { MessageTextCircle02 } from "./MessageTextCircle02";
